module.exports = __webpack_public_path__ + "static/media/ISO.2824722e.svg";